import BASKET_ROWS_TYPES from '@constants/basketRowsTypes';

const matchBasketAddonRow =
  ({ addonIri, day, dietIri }) =>
  row =>
    row?.['@type'] === BASKET_ROWS_TYPES.ADDON_ITEM &&
    row?.addon?.['@id'] === addonIri &&
    row?.day === day &&
    (row?.clientDiet ?? 'noDiet') === (dietIri ?? 'noDiet');

export default matchBasketAddonRow;
